import { GetMapObject, IsRootMapObject } from "../mapObjects";
import { Vector2i, IsString } from "js-vextensions";
import { StoreAccessor } from "mobx-firelink";
/** Returned array begins with immediate parent, and ends with root object. */
export const GetMapObjectAncestors = StoreAccessor("GetMapObjectAncestors", s => (obj) => {
    return GetMapObjectAncestors_FromParent(GetMapObject(obj.parent));
});
/** Returned array begins with provided parent, and ends with root object. */
export const GetMapObjectAncestors_FromParent = StoreAccessor("GetMapObjectAncestors_FromParent", s => (parent) => {
    if (parent == null)
        return null;
    let parents = [parent];
    let nextChild = parent;
    while (nextChild != null) {
        let newParent = GetMapObject(nextChild.parent);
        if (newParent == null)
            break;
        parents.push(newParent);
        nextChild = newParent;
    }
    // if we actually found the entire ancestor chain, return it; else return null
    if (parents.length && IsRootMapObject(parents.LastOrX())) {
        return parents;
    }
    return null;
});
export const GetMapObjectFinalPositions = StoreAccessor("GetMapObjectFinalPositions", s => (objects) => {
    return objects.ToMap(obj => obj._key.toString(), obj => GetMapObjectFinalPosition(obj));
});
export const GetMapObjectFinalPosition = StoreAccessor("GetMapObjectFinalPosition", s => (obj) => {
    let parent = GetMapObject(obj.parent);
    if (parent == null)
        return obj.position.As(Vector2i); // todo: maybe change this to be null (and somehow handle it upstream)
    let ancestorsOffset = GetAncestorsOffset(parent);
    if (ancestorsOffset == null)
        return obj.position.As(Vector2i);
    return obj.position.As(Vector2i).Plus(ancestorsOffset);
});
export const GetAncestorsOffset = StoreAccessor("GetAncestorsOffset", s => (parentOrParentID) => {
    let parent = IsString(parentOrParentID) ? GetMapObject(parentOrParentID) : parentOrParentID;
    if (parent == null)
        return null;
    let ancestors = GetMapObjectAncestors_FromParent(parent);
    if (ancestors == null)
        return null;
    let totalOffset = Vector2i.zero;
    for (let ancestor of ancestors) {
        totalOffset = totalOffset.Plus(ancestor.position);
    }
    return totalOffset;
});
